module.exports = __webpack_public_path__ + "static/media/contacts.b9f342b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/contacts.svg
// module id = 2093
// module chunks = 0